import { getCookie } from 'cookies-next'

// google cookie get
export function getGclid() {
  return (
    (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('gclid')) ||
    getCookie('gclid') ||
    null
  )
}
